// extracted by mini-css-extract-plugin
module.exports = {"galleryWrapper":"styles_galleryWrapper__g7iqg"};